import { useRepositoryMutation } from '@mews-commander/data-access';

export const useMutateMulticurrencyEarlyOptIn = () => {
    const { mutate } = useRepositoryMutation('multiCurrencyServiceConfiguration', 'earlyOptIn', {
        invalidateQueries: {
            multiCurrencyServiceConfiguration: ['get'],
        },
    });

    return { mutate };
};
